import { DEFAULT_CHUNK_SIZE } from "@custom-types/upload-manager-types";
import { TypedEvent } from "@faro-lotv/foundation";
import { CoreFileUploader } from "@utils/core-file-uploader";

/**
 * An object to manage a specific CoreFileUploader object and to connect it to the
 * object managing all uploads
 */
export class UploadController {
  abortController = new AbortController();
  uploadCompleted = new TypedEvent();
  uploadFailed = new TypedEvent();
  uploadUpdated = new TypedEvent();
  uploadCanceled = new TypedEvent();

  // TODO: Check the possibility to remove coreApi: https://faro01.atlassian.net/browse/ST-1902
  constructor(id, file, projectId, coreApi, chunkSizeMib = DEFAULT_CHUNK_SIZE) {
    this.id = id;
    this.uploader = new CoreFileUploader(file, projectId, coreApi);
    this.uploader.chunkSize = chunkSizeMib;
    this.uploader.uploadCompleted.on(({
      downloadUrl,
      md5
    }) => {
      this.uploadCompleted.emit({
        id: this.id,
        downloadUrl,
        md5
      });
    });
    this.uploader.uploadFailed.on(error => {
      this.uploadFailed.emit({
        id: this.id,
        fileName: file.name,
        error
      });
    });
    this.uploader.progressChanged.on(({
      progress,
      expectedEnd,
      speedMBps
    }) => {
      this.uploadUpdated.emit({
        id: this.id,
        progress,
        expectedEnd,
        speedMBps
      });
    });
    this.uploader.uploadCanceled.on(() => {
      this.uploadCanceled.emit({
        id: this.id,
        fileName: file.name
      });
    });
  }
}